var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5655 11.0774C3.76201 -3.69246 27.238 -3.69246 18.4345 11.0774C27.238 -3.69442 38.976 16 21.369 16C38.976 16 27.238 35.6925 18.4345 20.9226C27.238 35.6925 3.76201 35.6925 12.5655 20.9226C3.76201 35.6944 -7.97597 16 9.63101 16C-7.97597 16 3.76201 -3.69246 12.5655 11.0774ZM15.5 19C17.1569 19 18.5 17.6569 18.5 16C18.5 14.3431 17.1569 13 15.5 13C13.8431 13 12.5 14.3431 12.5 16C12.5 17.6569 13.8431 19 15.5 19Z",
    fill: "#C5AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.036c798b1a66eac9cc4390b624a96cc0.svg";
export { ForwardRef as ReactComponent };